import { mapKeys } from 'radashi'

export function useTailwind() {
  const styles = getComputedStyle(document.documentElement)
  const variable = (name: string) => styles.getPropertyValue(`--${name}`)

  const breakpoints = {
    'sm': variable('breakpoint-sm'),
    'md': variable('breakpoint-md'),
    'lg': variable('breakpoint-lg'),
    'xl': variable('breakpoint-xl'),
    '2xl': variable('breakpoint-2xl'),
  }

  const mediaQuery = (breakpoint: string): `(width >= ${string})` | `(width < ${string})` | undefined => {
    if (breakpoint.startsWith('max-')) {
      const bp = breakpoint.slice(4)
      if (bp in breakpoints) {
        return `(width < ${breakpoints[bp as keyof typeof breakpoints]})`
      }
      return undefined
    }
    else if (breakpoint in breakpoints) {
      return `(width >= ${breakpoints[breakpoint as keyof typeof breakpoints]})`
    }
    return undefined
  }

  return {
    variable,
    breakpoints,
    /**
     * Returns a media query string for the given breakpoint.
     * @example
     * mq('md') // '(width >= 768px)'
     * mq('max-md') // '(width < 768px)'
     */
    mediaQuery,
    /**
     * Maps a breakpoint object to a media query object.
     * @example
     * mapMediaQueries({ md: 'foo' }) // { '(width >= 768px)': 'foo' }
     * mapMediaQueries({ 'max-md': 'bar' }) // { '(width < 768px)': 'bar' }
     */
    mapMediaQueries: (breakpoints: Record<string, unknown>) =>
      mapKeys(breakpoints, (value) => {
        if (typeof value === 'string') {
          return mediaQuery(value) ?? value
        }
        return value
      }),
  }
}
